// Jeu d'icônes dessinées à la main (SVG), inspiré des applications sociales
// mais avec ses propres tracés. Aucun émoji : le rendu est identique partout.
//
// Chaque icône est un ou plusieurs tracés pensés pour fonctionner dans les deux états :
//   • contour  (fill: none  + stroke)  → onglet au repos
//   • plein    (fill: currentColor)    → onglet actif, comme sur Facebook
// Les tracés « creusés » utilisent fill-rule="evenodd".

const T = {
  // ---------------------------------------------------------- barre du bas
  fil: `<path d="M3.4 10.9 12 3.3l8.6 7.6v8.2a2 2 0 0 1-2 2h-3.7v-6.2H9.1v6.2H5.4a2 2 0 0 1-2-2z"/>`,

  reels: `<path fill-rule="evenodd" d="M6.4 3.4h11.2a3 3 0 0 1 3 3v11.2a3 3 0 0 1-3 3H6.4a3 3 0 0 1-3-3V6.4a3 3 0 0 1 3-3zm3.8 5.1v7l6-3.5z"/>`,

  membres: `<path d="M9 4.3a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8z"/>
            <path d="M2.9 20.7v-.9c0-3.4 2.8-5.2 6.1-5.2s6.1 1.8 6.1 5.2v.9z"/>
            <path d="M17 5.6a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6z"/>
            <path d="M15.9 13.9c.4-.1.8-.1 1.2-.1 2.8 0 4.4 1.5 4.4 4.2v.8h-3.3"/>`,

  messages: `<path d="M9.4 3.4c3.9 0 7 2.6 7 5.9s-3.1 5.9-7 5.9c-.6 0-1.2-.1-1.8-.2l-3.5 1.7.7-2.9c-1.5-1.1-2.4-2.7-2.4-4.5 0-3.3 3.1-5.9 7-5.9z"/>
             <path d="M18 8.7c2.4.8 4 2.6 4 4.8 0 1.5-.8 2.9-2 3.8l.6 2.5-3-1.5c-.5.1-1 .2-1.6.2-2.5 0-4.7-1.1-5.7-2.7"/>`,

  alertes: `<path d="M12 3.1a5.8 5.8 0 0 0-5.8 5.8v3.3l-1.7 3.4a.9.9 0 0 0 .8 1.3h13.4a.9.9 0 0 0 .8-1.3l-1.7-3.4V8.9A5.8 5.8 0 0 0 12 3.1z"/>
            <path d="M9.7 19.4a2.4 2.4 0 0 0 4.6 0"/>`,

  profil: `<path d="M12 4.2a3.7 3.7 0 1 1 0 7.4 3.7 3.7 0 0 1 0-7.4z"/>
           <path d="M4.5 20.8v-.5c0-3.8 3.4-5.9 7.5-5.9s7.5 2.1 7.5 5.9v.5z"/>`,

  // ------------------------------------------- actions sous les publications
  // Mains jointes : deux paumes symétriques qui se touchent au centre, poignets en bas.
  amen: `<g transform="rotate(-11 12 13)">
           <path d="M11.3 16.6V6.4c0-1.4-1.1-2.3-2.1-1.7-1 .6-1.8 2.4-2.1 4.6-.2 1.9-.1 3.6.4 4.9.5 1.4 1.6 2.3 3 2.4z"/>
           <path d="M12.7 16.6V6.4c0-1.4 1.1-2.3 2.1-1.7 1 .6 1.8 2.4 2.1 4.6.2 1.9.1 3.6-.4 4.9-.5 1.4-1.6 2.3-3 2.4z"/>
           <path d="M9.4 17h5.2a1.7 1.7 0 0 1 1.7 1.7v.6a1.7 1.7 0 0 1-1.7 1.7H9.4a1.7 1.7 0 0 1-1.7-1.7v-.6A1.7 1.7 0 0 1 9.4 17z"/>
         </g>`,

  commenter: `<path d="M12 3.6c4.8 0 8.7 3.2 8.7 7.2s-3.9 7.2-8.7 7.2c-.9 0-1.7-.1-2.5-.3l-4.5 2.3 1-3.8c-1.7-1.3-2.7-3.2-2.7-5.4 0-4 3.9-7.2 8.7-7.2z"/>`,

  partager: `<path d="M4.1 19c.7-4.2 3.9-6.7 8.5-6.9V8.4c0-.7.8-1.1 1.4-.7l6.6 5.3c.4.4.4 1 0 1.4l-6.6 5.3c-.6.4-1.4 0-1.4-.7v-3.7c-3.4.1-5.9 1.4-7.5 3.9a.6.6 0 0 1-1-.2z"/>`,

  // Silhouette par défaut des avatars : elle remplit le rond, comme sur Facebook.
  avatarVide: `<path d="M12 4.4a4.7 4.7 0 1 1 0 9.4 4.7 4.7 0 0 1 0-9.4z"/>
               <path d="M12 15.2c6.1 0 11 4 11 9H1c0-5 4.9-9 11-9z"/>`,

  appareil: `<path d="M4 7.6h3.1l1.4-2.3h7l1.4 2.3H20a2.1 2.1 0 0 1 2.1 2.1v7.9a2.1 2.1 0 0 1-2.1 2.1H4a2.1 2.1 0 0 1-2.1-2.1V9.7A2.1 2.1 0 0 1 4 7.6z"/>
             <path d="M12 10.3a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8z"/>`,

  // -------------------------------------------------------------- divers
  recherche: `<path d="M11 4.3a6.7 6.7 0 1 1 0 13.4 6.7 6.7 0 0 1 0-13.4z"/>
              <path d="m16 16 4.4 4.4"/>`,

  photo: `<path d="M4.2 5.4h15.6a2 2 0 0 1 2 2v9.2a2 2 0 0 1-2 2H4.2a2 2 0 0 1-2-2V7.4a2 2 0 0 1 2-2z"/>
          <path d="m2.6 16.4 4.9-4.6 3.7 3.3 3.6-3 6.6 5.4"/>
          <path d="M15.8 8a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6z"/>`,

  video: `<path d="M3.6 6.4h9.2a2.2 2.2 0 0 1 2.2 2.2v6.8a2.2 2.2 0 0 1-2.2 2.2H3.6a2.2 2.2 0 0 1-2.2-2.2V8.6a2.2 2.2 0 0 1 2.2-2.2z"/>
          <path d="m15 10.6 5.4-3.2c.6-.3 1.2.1 1.2.8v7.6c0 .7-.6 1.1-1.2.8L15 13.4z"/>`,

  son: `<path d="M4 9.4h3l4.4-3.6c.5-.4 1.2 0 1.2.6v11.2c0 .6-.7 1-1.2.6L7 14.6H4a.9.9 0 0 1-.9-.9v-3.4A.9.9 0 0 1 4 9.4z"/>
        <path d="M15.6 9.2a4 4 0 0 1 0 5.6"/>
        <path d="M18.2 6.6a7.6 7.6 0 0 1 0 10.8"/>`,

  muet: `<path d="M4 9.4h3l4.4-3.6c.5-.4 1.2 0 1.2.6v11.2c0 .6-.7 1-1.2.6L7 14.6H4a.9.9 0 0 1-.9-.9v-3.4A.9.9 0 0 1 4 9.4z"/>
         <path d="m16 9.6 4.8 4.8m0-4.8L16 14.4"/>`,

  envoyer: `<path d="M3.3 11.2 20 4.1c.7-.3 1.4.4 1.1 1.1l-7.1 16.7c-.3.7-1.3.7-1.5 0l-2.2-6.6-6.6-2.2c-.7-.2-.7-1.2 0-1.5z"/>`,

  plus: `<path d="M12 5.2v13.6M5.2 12h13.6"/>`,
  /* Une flèche qui descend vers un plateau : le dessin universel du
     téléchargement. Au TRAIT et non plein — elle vit dans l'en-tête, à côté de
     la cloche, et deux formes pleines côte à côte s'empâtent. */
  telecharger: `<path d="M12 3.6v10.8M7.6 10.4 12 14.8l4.4-4.4"/><path d="M4.4 16.8v1.6a2 2 0 0 0 2 2h11.2a2 2 0 0 0 2-2v-1.6"/>`,

  retour: `<path d="M14.6 5.4 8 12l6.6 6.6"/>`,

  fermer: `<path d="m6 6 12 12M18 6 6 18"/>`,

  // Le micro des messages vocaux : une capsule, un arceau, un pied.
  micro: `<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3"/>`,

  // Le trombone des pièces jointes. Tout le monde le reconnaît, y compris ceux
  // qui n'ont jamais vu un vrai trombone de bureau.
  trombone: `<path d="M20.4 11.1 12 19.5a5.3 5.3 0 0 1-7.5-7.5l8.5-8.4a3.5 3.5 0 0 1 5 5l-8.5 8.4a1.8 1.8 0 0 1-2.5-2.5l7.8-7.8"/>`,

  // Accusés de lecture. Un trait : le message est parti. Deux traits : il a été
  // ouvert. Le second trait n'est pas un second crochet entier — il se glisse
  // derrière le premier, comme partout ailleurs, sinon la marque devient plus
  // large que l'heure qu'elle accompagne.
  //
  // ⚠️ L'ÉCART ENTRE LES DEUX EST CE QUI FAIT TOUT. Il était de 2,5 unités sur
  // 24 : à la taille où cette marque s'affiche — 15 px — cela fait moins de
  // deux pixels, et les deux traits se fondaient en un seul, plus épais. On ne
  // distinguait plus « envoyé » de « lu ». Il est maintenant de 5,5 unités, et
  // le premier crochet est repoussé à gauche pour que l'ensemble tienne dans
  // la même largeur qu'avant.
  trait: `<path d="m4 12.6 5 5.4L20 6.2"/>`,
  traits: `<path d="m0.5 12.6 5 5.4L15 7"/><path d="m11 18 9.5-11"/>`,

  // Le sceau de certification : un disque dentelé, et la coche en réserve à
  // l'intérieur. Le tracé est unique et se remplit d'une seule couleur, si bien
  // que le sceau reste lisible à 14 px, la taille d'un nom.
  certifie: `<path fill-rule="evenodd" d="M12 1.6l2.4 2 3.1-.3 1 3 2.7 1.6-.9 3 .9 3-2.7 1.6-1 3-3.1-.3-2.4 2-2.4-2-3.1.3-1-3L2.8 15l.9-3-.9-3 2.7-1.6 1-3 3.1.3 2.4-2zm4.5 7.2a1 1 0 0 0-1.5-1.3l-4.2 4.8-1.8-1.8a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.5-.1l4.8-5.6z"/>`,

  // drapeau : les Pages, comme la « page » d'une église ou d'un ministère
  drapeau: `<path d="M5.4 21V4.2"/>
            <path d="M5.4 4.6c3.6-1.6 6.2 1.6 9.8 0 1.4-.6 2.4-.6 3.4-.2v9.4c-1-.4-2-.4-3.4.2-3.6 1.6-6.2-1.6-9.8 0z"/>`,

  menu: `<path d="M3.8 6.6h16.4M3.8 12h16.4M3.8 17.4h16.4"/>`,

  // œil ouvert / œil barré : afficher ou masquer un mot de passe
  oeil: `<path d="M1.8 12s3.7-6.4 10.2-6.4S22.2 12 22.2 12s-3.7 6.4-10.2 6.4S1.8 12 1.8 12z"/>
         <path d="M12 9.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6z"/>`,
  oeilBarre: `<path d="M9.9 5.8c.7-.1 1.4-.2 2.1-.2 6.5 0 10.2 6.4 10.2 6.4a17 17 0 0 1-3 3.7"/>
              <path d="M6.4 7.5A16.6 16.6 0 0 0 1.8 12s3.7 6.4 10.2 6.4c1.7 0 3.2-.4 4.5-1.1"/>
              <path d="M10 10.1a2.8 2.8 0 0 0 3.9 3.9"/>
              <path d="m3.4 3.4 17.2 17.2"/>`,

  // livre ouvert : le verset, la charte, tout ce qui s'écrit et se relit
  verset: `<path d="M12 6.6C10.2 5.2 7.9 4.6 5.1 4.8a1 1 0 0 0-.9 1v11.4a1 1 0 0 0 1.1 1c2.5-.2 4.7.3 6.7 1.6"/>
           <path d="M12 6.6c1.8-1.4 4.1-2 6.9-1.8a1 1 0 0 1 .9 1v11.4a1 1 0 0 1-1.1 1c-2.5-.2-4.7.3-6.7 1.6"/>
           <path d="M12 6.6v13.2"/>`,

  options: `<path d="M6 12a1.6 1.6 0 1 1-3.2 0A1.6 1.6 0 0 1 6 12zm7.6 0a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zm7.6 0a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0z"/>`,

  /* ------------------------------------------- les pastilles de notification
     Elles sont TOUJOURS dessinées pleines, en blanc sur un disque de couleur,
     et à 12 px. D'où trois règles de tracé qui ne valent que pour elles :
     un seul volume par idée, aucun détail sous une unité de large, et les
     creux obtenus par `fill-rule="evenodd"` plutôt que par un contour — un
     contour de 1,7 disparaît à cette taille. */

  // L'étiquette des mentions : le losange percé que tout le monde reconnaît.
  etiquette: `<path fill-rule="evenodd" d="M12.2 2.4H20a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-.47 1.13l-8.2 8.2a1.6 1.6 0 0 1-2.26 0l-8.7-8.7a1.6 1.6 0 0 1 0-2.26l8.2-8.2a1.6 1.6 0 0 1 1.13-.47zm5 3.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4z"/>`,

  // Une silhouette et un « + » : la demande d'amitié.
  amiPlus: `<path d="M9.1 3.6a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"/>
            <path d="M9.1 13.2c4.1 0 7.4 2.2 7.4 5.6v1.4H1.7v-1.4c0-3.4 3.3-5.6 7.4-5.6z"/>
            <path d="M18 3.1h2.2v3.4h3.4v2.2h-3.4v3.4H18V8.7h-3.4V6.5H18z"/>`,

  // La même silhouette, mais avec une coche : celui-là ne demande rien, il suit.
  amiCoche: `<path d="M9.1 3.6a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"/>
             <path d="M9.1 13.2c4.1 0 7.4 2.2 7.4 5.6v1.4H1.7v-1.4c0-3.4 3.3-5.6 7.4-5.6z"/>
             <path d="m14.2 7.4 1.5-1.5 1.9 1.9 3.8-3.8 1.5 1.5-5.3 5.3z"/>`,

  /* Deux silhouettes : l'amitié conclue.
     ⚠️ Ce n'est PAS `membres`, qui sert la barre du bas. Celui-là est dessiné
     pour le contour, et son second personnage est un tracé OUVERT — parfait en
     trait, mais rempli il devient un croissant qu'on ne reconnaît plus. Une
     pastille est toujours pleine : il lui faut ses propres volumes fermés. */
  amisDeux: `<path d="M8.7 4.6a3.7 3.7 0 1 1 0 7.4 3.7 3.7 0 0 1 0-7.4z"/>
             <path d="M8.7 13.3c4 0 7.2 2.2 7.2 5.5v1.2H1.5v-1.2c0-3.3 3.2-5.5 7.2-5.5z"/>
             <path d="M17.5 3.8a2.9 2.9 0 1 1 0 5.8 2.9 2.9 0 0 1 0-5.8z"/>
             <path d="M17.5 11c3 0 5 1.8 5 4.5v1.1h-4.8c-.3-2.2-1.5-4-3.4-5.1 1-.3 2.1-.5 3.2-.5z"/>`,

  /* ⚠️ Sept tracés ont vécu ici : un pouce, un cœur et quatre visages, pour les
     réactions. Ils ont été retirés — les réactions sont des ÉMOJIS, et elles
     sont le seul endroit de l'application où l'on en pose. La raison est dans
     `js/reactions.js` : à la taille où une réaction s'affiche, un tracé blanc
     sur un disque ne dit pas la moitié de ce que dit l'émoji, et « Haha » et
     « Wouah » dessinés se ressemblaient trop. */

  // Répondre à un message précis : la flèche qui revient en arrière.
  repondre: `<path d="M10.4 4.6v3.9c5.6.3 9.4 3.6 10.6 9.4a.6.6 0 0 1-1 .5c-2-2.5-4.9-3.8-9.6-3.9v3.9c0 .7-.8 1.1-1.4.7l-6.6-5.3a.9.9 0 0 1 0-1.4l6.6-5.5c.6-.4 1.4 0 1.4.7z"/>`,

  // Corbeille : supprimer pour de bon.
  corbeille: `<path d="M9.4 2.6h5.2a1 1 0 0 1 1 1v1.2h4.2a1 1 0 1 1 0 2H4.2a1 1 0 0 1 0-2h4.2V3.6a1 1 0 0 1 1-1z"/>
              <path d="M5.8 8.6h12.4l-.9 11.1a1.8 1.8 0 0 1-1.8 1.7H8.5a1.8 1.8 0 0 1-1.8-1.7z"/>`,

  // Crayon : modifier ce qu'on vient d'écrire.
  crayon: `<path d="m14.9 4.5 4.6 4.6-9.7 9.7-5.6 1 1-5.6z"/>
           <path d="m16.4 3 1.7-1.7a1.6 1.6 0 0 1 2.3 0l2.3 2.3a1.6 1.6 0 0 1 0 2.3L21 7.6z"/>`,
};

/* L'Amen des pastilles.
   Le tracé des publications ne descend pas à 12 px. Agrandi, il ne s'arrange
   pas : ses deux paumes sont séparées d'une unité et demie sur 24, et cette
   fente est le seul détail qu'on distingue encore — les mains jointes se
   lisaient comme deux doigts écartés, poignet compris dans la perte. Celui-ci
   fait les mêmes gestes, mais les paumes se touchent presque et le poignet est
   franc : à 12 px il forme une silhouette unique, ce qui est tout ce qu'une
   pastille peut porter. */
T.amenPastille = `<g transform="rotate(-8 12 12)">
    <path d="M11.6 17.6V3.6c0-2-1.5-3.2-3-2.3C7.1 2.2 6 4.8 5.6 7.9c-.3 2.6-.1 5 .5 6.8.7 1.9 2.2 2.8 4.1 2.9z"/>
    <path d="M12.4 17.6V3.6c0-2 1.5-3.2 3-2.3 1.5.9 2.6 3.5 3 6.6.3 2.6.1 5-.5 6.8-.7 1.9-2.2 2.8-4.1 2.9z"/>
    <path d="M9.3 18.1h5.4a2.2 2.2 0 0 1 2.2 2.2v.5a2.2 2.2 0 0 1-2.2 2.2H9.3a2.2 2.2 0 0 1-2.2-2.2v-.5a2.2 2.2 0 0 1 2.2-2.2z"/>
  </g>`;

// Icônes toujours dessinées en contour (un remplissage les rendrait illisibles).
const TOUJOURS_CONTOUR = new Set(["recherche", "photo", "video", "son", "muet", "plus", "retour", "fermer", "appareil", "menu", "drapeau", "verset", "oeil", "oeilBarre", "micro"]);

/**
 * Renvoie le code SVG d'une icône.
 * @param {string} nom      clé du tracé
 * @param {object} o        { taille, plein, classe }
 */
export function icone(nom, o = {}) {
  const tracé = T[nom];
  if (!tracé) return "";
  const taille = o.taille || 24;
  const plein = o.plein && !TOUJOURS_CONTOUR.has(nom);
  const style = plein
    ? 'fill="currentColor" stroke="none"'
    : 'fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  return `<svg class="icone ${o.classe || ""}" width="${taille}" height="${taille}" viewBox="0 0 24 24" ${style} aria-hidden="true">${tracé}</svg>`;
}

/**
 * Paire contour + plein : le CSS affiche l'un ou l'autre selon `.est-actif`.
 * C'est ce qui donne l'effet « icône qui se remplit » des barres de navigation.
 */
export function iconeDuo(nom, taille = 24) {
  return `<span class="icone-duo">${icone(nom, { taille, classe: "icone--trait" })}${icone(nom, {
    taille,
    plein: true,
    classe: "icone--plein",
  })}</span>`;
}

export default icone;
